import { 
  PIPE_OPENING_REQUEST, 
  CREATE_PIPE_OPENING, 
  GET_PIPE_OPENINGS, 
  GET_PIPE_OPENINGS_PAGE, 
  UPDATE_PIPE_OPENING, 
  DELETE_PIPE_OPENING, 
  PIPE_OPENING_REQUEST_FAILURE, 
  PIPE_OPENING_REQUEST_SUCCESS 
} from '../types';

const initialState = {
  pipeOpenings: [],
  pipeOpeningsPage: [],
  loading: false,
  error: null,
};


const pipeOpeningReducer = (state = initialState, action) => {
  switch (action.type) {
    case PIPE_OPENING_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PIPE_OPENINGS: {
      return {
        ...state,
        pipeOpenings: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PIPE_OPENINGS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
        ...state,
        pipeOpeningsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
        }
    }
    case CREATE_PIPE_OPENING:
      return {
        ...state,
        pipeOpenings: [action.payload, ...state.pipeOpenings],
        loading: false,
        error: null
      };
    case UPDATE_PIPE_OPENING:
      const pipeOpeningsData = state.pipeOpenings.slice(0);
      const uIndex = pipeOpeningsData.findIndex((data) => data.id === action.payload.id);
      pipeOpeningsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        pipeOpenings: [ ...pipeOpeningsData ],
        loading: false,
        error: null
      };
    case DELETE_PIPE_OPENING:
      const pipeOpenings = state.pipeOpenings?.slice(0);
      const index = pipeOpenings.findIndex((data) => data.id === action.id);
      if (index > -1) {
        pipeOpenings.splice(index, 1);
      }
      return {
        ...state,
        pipeOpenings: [...pipeOpenings],
        loading: false,
        error: null
      }
    case PIPE_OPENING_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case PIPE_OPENING_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default pipeOpeningReducer;
